// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_refunds_exchange_body = /** @type {(inputs: {}) => string} */ () => {
	return `If you received a defective or incorrect item, please contact us and we will arrange an exchange or full refund at no extra cost to you.`
};

const el_refunds_exchange_body = /** @type {(inputs: {}) => string} */ () => {
	return `Αν λάβατε ελαττωματικό ή λανθασμένο προϊόν, επικοινωνήστε μαζί μας και θα κανονίσουμε αντικατάσταση ή πλήρη επιστροφή χρημάτων χωρίς επιπλέον κόστος.`
};

const ru_refunds_exchange_body = /** @type {(inputs: {}) => string} */ () => {
	return `Если вы получили неисправный или неправильный товар, свяжитесь с нами, и мы организуем обмен или полный возврат средств без дополнительных затрат.`
};

const he_refunds_exchange_body = /** @type {(inputs: {}) => string} */ () => {
	return `אם קיבלתם מוצר פגום או שגוי, צרו איתנו קשר ונסדר החלפה או החזר כספי מלא ללא עלות נוספת.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const refunds_exchange_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.refunds_exchange_body(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("refunds_exchange_body", locale)
	if (locale === "en") return en_refunds_exchange_body(inputs)
	if (locale === "el") return el_refunds_exchange_body(inputs)
	if (locale === "ru") return ru_refunds_exchange_body(inputs)
	if (locale === "he") return he_refunds_exchange_body(inputs)
	return "refunds_exchange_body"
};